module.exports = __webpack_public_path__ + "img/receiptsign_mingliang.207e74ae.png";